import React, { useRef, useEffect, useState } from "react";
import Video from "app/(home)/Accueil.mp4";
import PageArchiveVideo from "app/(archives)/videos/page";
import PagePhotos from "app/photos/PagePhotos";
import PageContact from "app/(others)/contact/page";
import ImageMapper from "react-img-mapper";
import "../../styles/styles.css";
import PageArticles from "app/articles/PageArticles";
import PageEvenements from "app/evenements/PageEvenements";

const URL = "images/transparentBg.png";

export default function PageHome() {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const videoRef = useRef<HTMLVideoElement | null>(null);

  // 🔥 Fonction pour MAJ les dimensions
  const updateSize = () => {
    if (!videoRef.current) return;
    const rect = videoRef.current.getBoundingClientRect();
    setSize({ width: rect.width, height: rect.height });
  };

  // 🔥 Détecte la taille EXACTE dès que la vidéo est prête
  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    const handleLoaded = () => updateSize();

    video.addEventListener("loadedmetadata", handleLoaded);
    window.addEventListener("resize", updateSize);

    return () => {
      video.removeEventListener("loadedmetadata", handleLoaded);
      window.removeEventListener("resize", updateSize);
    };
  }, []);

  const { width, height } = size;

  const MAP = {
    name: "my-map",
    areas: [
      { name: "1", shape: "poly", coords: [0, 0, width / 3, 0, width / 3, height / 3, 0, height / 3], href: `/video?videoUrl=${encodeURIComponent("https://www.tiktok.com/@ahuncycle/video/7284419945478262022")}` },
      { name: "2", shape: "poly", coords: [width / 3, 0, (2 * width) / 3, 0, (2 * width) / 3, height / 3, width / 3, height / 3], href: `/video?videoUrl=${encodeURIComponent("https://www.tiktok.com/@ahuncycle/video/7109204418087619845")}` },
      { name: "3", shape: "poly", coords: [(2 * width) / 3, 0, width, 0, width, height / 3, (2 * width) / 3, height / 3], href: `/video?videoUrl=${encodeURIComponent("https://www.tiktok.com/@ahuncycle/video/7029045410509655302")}` },
      { name: "4", shape: "poly", coords: [0, height / 3, width / 3, height / 3, width / 3, (2 * height) / 3, 0, (2 * height) / 3], href: `/video?videoUrl=${encodeURIComponent("https://www.tiktok.com/@ahuncycle/video/7051330123043179781")}` },
      { name: "5", shape: "poly", coords: [width / 3, height / 3, (2 * width) / 3, height / 3, (2 * width) / 3, (2 * height) / 3, width / 3, (2 * height) / 3], href: `/video?videoUrl=${encodeURIComponent("https://www.youtube.com/watch?v=bObhZz0aySo")}` },
      { name: "6", shape: "poly", coords: [(2 * width) / 3, height / 3, width, height / 3, width, (2 * height) / 3, (2 * width) / 3, (2 * height) / 3], href: "" },
      { name: "7", shape: "poly", coords: [0, (2 * height) / 3, width / 3, (2 * height) / 3, width / 3, height, 0, height], href: `/video?videoUrl=${encodeURIComponent("https://www.tiktok.com/@ahuncycle/video/7175685890998799622")}` },
      { name: "8", shape: "poly", coords: [width / 3, (2 * height) / 3, (2 * width) / 3, (2 * height) / 3, (2 * width) / 3, height, width / 3, height], href: `/video?videoUrl=${encodeURIComponent("https://www.tiktok.com/@ahuncycle/video/7149315000673307909")}` },
      { name: "9", shape: "poly", coords: [(2 * width) / 3, (2 * height) / 3, width, (2 * height) / 3, width, height, (2 * width) / 3, height], href: `/video?videoUrl=${encodeURIComponent("https://www.youtube.com/watch?v=8hImxk259l4")}` },
    ],
  };

  return (
    <>
      <div className="fullScreen">
        <div className="parent">
          <div className="overlay" style={{ maxHeight: height }}>
            {width > 0 && height > 0 && (
              <ImageMapper 
                src={URL} 
                map={MAP} 
                width={width} 
                height={height} 
                strokeColor="#00FF00"   // contour vert
                lineWidth={5}
                fillColor="rgba(150,220,150, 0.5)"/>
            )}
          </div>

          <video ref={videoRef} autoPlay loop muted className="center bg-vid">
            <source src={Video} type="video/mp4" />
          </video>
        </div>
      </div>
      <PageArticles nombre={3} />
      <PageEvenements nombre={3} />
      <PagePhotos nombre={3} />
      <PageArchiveVideo nombre={3} />
      <PageContact />
    </>
  );
}
